import React from 'react';
import LandingPage from './LandingPage';
import './style/main.css';

function App() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default App;
